import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from 'view/common/with-async';

export const ConsentForm = withAsync({
    loader: lazyForPaint(() => import(/* webpackChunkName: "consent-form" */ './hocs')),
});
